var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-vstack"},_vm._l((_vm.filtered),function(item,index){return _c('Cell',{key:index,attrs:{"chain":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }